import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import Footer from "components/footers/FiveColumnWithInputForm.js";
import ContactUsForm from "components/forms/TwoColContactUsWithIllustrationFullForm.js";
import ContactDetails from "components/cards/ThreeColContactDetails.js";
import Header from "components/headers/Header";

const Address = tw.span`leading-relaxed`;
const AddressLine = tw.span`block`;
const Email = tw.span`text-sm mt-6 block text-gray-500`;
const Phone = tw.span`text-sm mt-0 block text-gray-500`;

export default () => {
  return (
    <AnimationRevealPage>
      <Header />
      <ContactUsForm />
      {/* <ContactDetails
        cards={[
          {
            title: "South Korea",
            description: (
              <>
                <Address>
                  <AddressLine>ddd</AddressLine>
                  <AddressLine>sss</AddressLine>
                </Address>
                <Email>admin@arrghsoft.com</Email>
                <Phone>+1 (203) 991-6988</Phone>
              </>
            )
          },
        ]}
      />  */}
      <Footer />
    </AnimationRevealPage>
  );
};
